<template>
  <el-row>
    <el-col>
      <transition name="slide-fade" mode="out-in">
        <RabbeyTable3
          ref="table_new"
          v-loading="loading"
          :columns="columns"
          :data="leads"
          :actions="actions"
          @rtable-push-action="handlePushAction"
        />
      </transition>
    </el-col>
    <LeadsDetails ref="LeadsDetails" />
  </el-row>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import LeadsDetails from "@/views/modules/call_center/Leads/LeadsDetails";

import { formatDate } from "@/utils";

import {} from "vuex";

export default {
  name: "leadList",
  data() {
    return {
      loading: false,
      drawer: false,
      leads: [],
      columns: [
        {
          prop: "Id",
          label: "No.",
          minWidth: 100,
          fixed: true
        },

        {
          prop: "FullName",
          label: "Nombre",
          minWidth: 200,
          fixed: true
        },
        {
          prop: "PhoneNumber",
          label: "Telefono",
          minWidth: 150,
          fixed: true
        },
        {
          prop: "Email",
          label: "Correo",
          minWidth: 200,
          fixed: true
        },
        {
          prop: "From",
          label: "Origen",
          minWidth: 200,
          fixed: true
        },

        {
          prop: "Subjet",
          label: "Asuto",
          minWidth: 200,
          fixed: true
        },
        {
          prop: "Comment",
          label: "Comentario",
          minWidth: 200,
          fixed: true
        },
        {
          prop: "CreatedAt",
          label: "Creación",
          minWidth: 200,
          fixed: true,
          formatter: (row) => formatDate(row.CreatedAt, "DD/MM/yyyy")
        }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        }
      ],
      companyId: this.$store.state.user.user.CompanySelected
    };
  },
  mounted() {
    this.getAllLeads();
  },
  created() {},
  components: {
    RabbeyTable3,
    LeadsDetails
  },
  methods: {
    handlePushAction(command) {
      switch (command.command) {
        case "view":
          this.$refs.LeadsDetails.show(command.row);
          break;

        default:
          break;
      }
    },

    getAllLeads() {
      this.loading = true;
      this.$http
        .get(`/api/leads/GetLeads`)
        .then((response) => {
          if (response.status === 200) {
            this.leads = response.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
